import {
  MobileStateItemBase,
  MobileStateQuestion,
  SaveDataAnswerGroup,
} from '@safeguardproperties/corescript-react-npm/dist/types';
import React from 'react';
import CustomSingleSelect from '../../ui/atoms/CustomSingleSelect';
import CustomMultiSelect from '../../ui/atoms/CustomMultiSelect';
import CustomFormat from '../../ui/atoms/CustomFormat';
import CustomTextField from '../../ui/atoms/CustomTextField';
import CustomTypography from '../../ui/atoms/CustomTypography';
import CustomDatePicker from '../../ui/atoms/CustomDatePicker';
import SearchableDropDownSelector from '../../ui/atoms/CustomSearchableDropdown';

type QuestionItemViewProps = {
  question: MobileStateItemBase | any;
  answers: SaveDataAnswerGroup | undefined;
  disabled?: boolean;
  keyToString: (key: string) => string;
  onSetAnswer?: (questionKey: string, answers: string[]) => void;
};

const unsetOnSetAnswer = (questionKey: string, answers: string[]) => {
  console.error('On Set Answer was not passed to question', {
    QuestionPath: questionKey,
    Answers: answers,
  });
};

const QuestionItemView: React.FC<QuestionItemViewProps> = (props) => {
  const { question, disabled, answers, keyToString, onSetAnswer } = props;
  const typedQuestion = question as MobileStateQuestion;

  if (question.Type === 'SingleSelect') {
    return (
      <CustomSingleSelect
        question={typedQuestion}
        answers={answers}
        disabled={disabled}
        stringMapper={keyToString}
        onSetAnswer={onSetAnswer || unsetOnSetAnswer}
      />
    );
  }
  if (question.Type === 'SingleSelectFilter') {
    return (
      <SearchableDropDownSelector
        question={typedQuestion}
        answers={answers}
        disabled={disabled}
        stringMapper={keyToString}
        onSetAnswer={onSetAnswer || unsetOnSetAnswer}
      />
    );
  }

  if (question.Type === 'MultiSelect') {
    return (
      <CustomMultiSelect
        question={typedQuestion}
        answers={answers}
        disabled={disabled}
        stringMapper={keyToString}
        onSetAnswer={onSetAnswer || unsetOnSetAnswer}
      />
    );
  }

  if (question.Type === 'Phone') {
    return (
      <CustomFormat
        question={typedQuestion}
        answers={answers}
        stringMapper={keyToString}
        onSetAnswer={onSetAnswer || unsetOnSetAnswer}
        disabled={disabled}
        format='(###) ###-####'
        prefix='+1 '
      />
    );
  }

  if (
    question.Type === 'TextField' ||
    question.Type === 'MultiLineText' ||
    question.Type === 'Currency' ||
    question.Type === 'Numeric'
  ) {
    return (
      <CustomTextField
        question={typedQuestion}
        answers={answers}
        disabled={disabled}
        stringMapper={keyToString}
        onSetAnswer={onSetAnswer || unsetOnSetAnswer}
      />
    );
  }

  if (question.Type === 'Date') {
    return (
      <CustomDatePicker
        question={typedQuestion}
        answers={answers}
        disabled={disabled}
        stringMapper={keyToString}
        onSetAnswer={onSetAnswer || unsetOnSetAnswer}
      />
    );
  }

  if (question.Type === 'Equation') {
    return (
      <CustomTextField
        question={typedQuestion}
        answers={answers}
        disabled={true}
        stringMapper={keyToString}
        onSetAnswer={onSetAnswer || unsetOnSetAnswer}
      />
    );
  }

  return (
    <CustomTypography variant='body1'>
      Default Render - {keyToString(question?.Type)}{' '}
      {keyToString(question?.Title)}
    </CustomTypography>
  );
};

export default React.memo(QuestionItemView);
